import {combineReducers} from 'redux';

import balanceReport from './balance-report/reducer';
import asyncReport from './async-report/reducer';

const organisation = combineReducers({
    asyncReport,
    balanceReport,
});

export default organisation;
